<template>
  <div class="flex-page">
    <a-form
      class="form"
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="贝展标题">{{info.title}}</a-form-item>
      <a-form-item label="贝展Logo">
        <img style="max-height: 100px" v-if="info.logo" :src="this.API + info.logo" alt="">
      </a-form-item>
      <a-form-item label="贝展海报">
        <img style="max-height: 200px" v-if="info.thumb" :src="this.API + info.thumb" alt="">
      </a-form-item>
      <a-form-item label="贝展简介">{{info.desc}}</a-form-item>
      <a-form-item label="贝展场地">{{info.place}}</a-form-item>
      <a-form-item label="详细地址">{{info.addr}}</a-form-item>
      <a-form-item label="经纬度">{{info.lat}},{{info.lng}}</a-form-item>
      <a-form-item label="主办方">{{info.zhuban}}</a-form-item>
      <a-form-item label="协办方">{{info.xieban}}</a-form-item>
      <a-form-item label="贝展时间">{{info.start_at}} - {{info.end_at}}</a-form-item>
      <a-form-item label="详细介绍">
        <div v-html="info.content"></div>
      </a-form-item>
    </a-form>
    <div class="buttons">
      <a-button type="primary" @click="update">编辑</a-button>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.form {
  padding: 40px;
}
.sec{
  margin: 15px;
}
img{
  max-width: 100%;
}
</style>

<script>
export default {
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 3,
        },
        wrapperCol: {
          span: 20,
        },
      },
      cateList: [],
      info: {},
    };
  },
  async created () {
    const id = this.$route.query.id;
    const r = await this.$axios.get('/exh/getInfo?id=' + id);
    if(r.status == 1){
      this.info = r.info
    }
  },
  methods: {
    update () {
      this.$router.push(`/exh/update?id=${this.info.id}`)
    }
  },
};
</script>